import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  useMediaQuery,
  Box,
  Theme,
} from '@mui/material'
import { IDetails } from '../../types/list.interface'

const Details = ({ details }: { details: IDetails }) => {
  const isSmallScreen = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))
  if (isSmallScreen) {
    return (
      <Box>
        <div
          style={{
            marginTop: '20px',
            backgroundColor: '#fff',
            boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.3)',
            borderRadius: '6px',
            padding: '8px',
            display: 'flex',
            flexDirection: 'column',
          }}
          data-testid="mock-details"
        >
          <div
            style={{
              border: 'none',
              paddingBottom: '.4rem',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <strong
              style={{
                fontSize: '0.9rem',
                fontFamily: 'Atlas-Grotesk-Bold',
                fontWeight: 'bold',
              }}
            >
              NDC/Item #:
            </strong>
            <span
              style={{
                fontSize: '0.87rem',
                fontFamily: 'Atlas-Grotesk-Web-Regular',
                paddingTop: '.4rem',
                paddingBottom: '.4rem',
              }}
            >
              {' '}
              {details['ndc']}
            </span>
          </div>
          <div
            style={{
              border: 'none',
              paddingBottom: '.4rem',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <strong
              style={{
                fontSize: '0.9rem',
                fontFamily: 'Atlas-Grotesk-Bold',
                fontWeight: 'bold',
              }}
            >
              Item Description:
            </strong>
            <span
              style={{
                fontSize: '0.87rem',
                fontFamily: 'Atlas-Grotesk-Web-Regular',
                paddingTop: '.4rem',
                paddingBottom: '.4rem',
              }}
            >
              {' '}
              {details['description']}
            </span>
          </div>
          <div
            style={{
              border: 'none',
              paddingBottom: '.4rem',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <strong
              style={{
                fontSize: '0.9rem',
                fontFamily: 'Atlas-Grotesk-Bold',
                fontWeight: 'bold',
              }}
            >
              Expiration:
            </strong>
            <span
              style={{
                fontSize: '0.87rem',
                fontFamily: 'Atlas-Grotesk-Web-Regular',
                paddingTop: '.4rem',
                paddingBottom: '.4rem',
              }}
            >
              {' '}
              {details['exp']}
            </span>
          </div>
          <div
            style={{
              border: 'none',
              paddingBottom: '.4rem',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <strong
              style={{
                fontSize: '0.9rem',
                fontFamily: 'Atlas-Grotesk-Bold',
                fontWeight: 'bold',
              }}
            >
              Lot:
            </strong>
            <span
              style={{
                fontSize: '0.87rem',
                fontFamily: 'Atlas-Grotesk-Web-Regular',
                paddingTop: '.4rem',
                paddingBottom: '.4rem',
              }}
            >
              {' '}
              {details['lot']}
            </span>
          </div>
          <div
            style={{
              border: 'none',
              paddingBottom: '.4rem',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <strong
              style={{
                fontSize: '0.9rem',
                fontFamily: 'Atlas-Grotesk-Bold',
                fontWeight: 'bold',
              }}
            >
              Quantity:
            </strong>
            <span
              style={{
                fontSize: '0.87rem',
                fontFamily: 'Atlas-Grotesk-Web-Regular',
                paddingTop: '.4rem',
                paddingBottom: '.4rem',
              }}
              data-testid="quantity"
            >
              {' '}
              {details['quantity']}
            </span>
          </div>
        </div>
      </Box>
    )
  } else {
    return (
      <TableContainer data-testid="mock-details" component={Paper} style={{ marginTop: '20px' }}>
        <Table style={{ borderCollapse: 'collapse' }}>
          <TableHead>
            <TableRow>
              <TableCell style={{ border: 'none', paddingBottom: '.4rem' }}>
                <strong style={{ fontSize: '0.9rem', fontFamily: 'Atlas-Grotesk-Bold' }}>
                  NDC/Item #
                </strong>
              </TableCell>
              <TableCell style={{ border: 'none', paddingBottom: '.4rem' }}>
                <strong style={{ fontSize: '0.9rem', fontFamily: 'Atlas-Grotesk-Bold' }}>
                  Item Description
                </strong>
              </TableCell>
              <TableCell style={{ border: 'none', paddingBottom: '.4rem' }}>
                <strong style={{ fontSize: '0.9rem', fontFamily: 'Atlas-Grotesk-Bold' }}>
                  Expiration
                </strong>
              </TableCell>
              <TableCell style={{ border: 'none', paddingBottom: '.4rem' }}>
                <strong style={{ fontSize: '0.9rem', fontFamily: 'Atlas-Grotesk-Bold' }}>
                  Lot
                </strong>
              </TableCell>
              <TableCell
                sx={{ textAlign: 'right' }}
                style={{ border: 'none', paddingBottom: '.4rem' }}
              >
                <strong style={{ fontSize: '0.9rem', fontFamily: 'Atlas-Grotesk-Bold' }}>
                  Quantity
                </strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody style={{ padding: 0 }}>
            <TableRow>
              <TableCell
                style={{
                  border: 'none',
                  paddingTop: 0,
                  fontSize: '0.87rem',
                  fontFamily: 'Atlas-Grotesk-Web-Regular',
                }}
              >
                {details['ndc']}
              </TableCell>
              <TableCell
                style={{
                  border: 'none',
                  paddingTop: 0,
                  fontSize: '0.87rem',
                  fontFamily: 'Atlas-Grotesk-Web-Regular',
                }}
              >
                {details['description']}
              </TableCell>
              <TableCell
                style={{
                  border: 'none',
                  paddingTop: 0,
                  fontSize: '0.87rem',
                  fontFamily: 'Atlas-Grotesk-Web-Regular',
                }}
              >
                {details['exp']}
              </TableCell>
              <TableCell
                style={{
                  border: 'none',
                  paddingTop: 0,
                  fontSize: '0.87rem',
                  fontFamily: 'Atlas-Grotesk-Web-Regular',
                }}
              >
                {details['lot']}
              </TableCell>
              <TableCell
                sx={{
                  textAlign: 'right',
                  fontSize: '0.87rem',
                  fontFamily: 'Atlas-Grotesk-Web-Regular',
                }}
                style={{ border: 'none', paddingTop: 0 }}
                data-testid="quantity"
              >
                {details['quantity']}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    )
  }
}

export default Details
